import _ from 'lodash'

// get paymentMethodType code from paymentProvider.
// returns serviceCode only if provider does not have internalCode
export default function getPaymentMethodType(provider) {
  const {
    paymentGatewayServiceCode: serviceCode,
    paymentProviderInternalCode: internalCode,
  } = provider
  const arr = [_.toUpper(serviceCode)]
  if (!_.isEmpty(internalCode)) {
    arr.push(_.toUpper(internalCode))
  }
  return arr.join('___')
}
